/* meshsouq motion. Requires ms-gsap.js and ms-scrolltrigger.js loaded first. */
(function () {
  'use strict';

  if (typeof gsap === 'undefined') return;
  if (window.ScrollTrigger) gsap.registerPlugin(ScrollTrigger);

  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initBoard(svg) {
    var cells = Array.prototype.slice.call(svg.querySelectorAll('.ms-board__cell'));
    if (!cells.length) return;

    var glows = cells.map(function (c) { return c.querySelector('.ms-board__glow'); });
    var leds = cells.map(function (c) { return c.querySelector('.ms-board__led'); });

    if (reduced) {
      // A dark board misrepresents the product, so the still frame still glows.
      // Middle row lit, mirroring the supplier photography.
      gsap.set([glows[3], glows[4], glows[5], leds[3], leds[4], leds[5]], { opacity: 1 });
      return;
    }

    gsap.to(svg, { y: -12, duration: 3.2, ease: 'sine.inOut', repeat: -1, yoyo: true });

    var tl = gsap.timeline({ repeat: -1, repeatDelay: 0.5 });
    // Nine panels, 0-8 reading left-to-right, top-to-bottom.
    var order = [4, 0, 8, 2, 6, 1, 7, 3, 5, 4, 0, 8];
    var pace = 0.52;

    order.forEach(function (i) {
      // Each hit is quicker than the last, which is the actual selling point:
      // the game accelerates as you keep up with it.
      pace = Math.max(0.17, pace * 0.88);
      tl.to([glows[i], leds[i]], { opacity: 1, duration: pace * 0.4, ease: 'power2.out' })
        .to([glows[i], leds[i]], { opacity: 0.18, duration: pace * 0.55, ease: 'power2.in' }, '+=' + pace * 0.18);
    });

    // Run completed: flash the whole board, then settle and start over.
    tl.to(glows.concat(leds), { opacity: 1, duration: 0.16, ease: 'power2.out' }, '+=0.12')
      .to(glows.concat(leds), { opacity: 0.18, duration: 0.5, ease: 'power2.inOut' });
  }

  function initReveals() {
    if (reduced || !window.ScrollTrigger) return;

    gsap.utils.toArray('[data-ms-reveal]').forEach(function (group) {
      var kids = group.children.length
        ? Array.prototype.slice.call(group.children)
        : [group];

      // fromTo INSIDE onEnter, never gsap.from() with a scrollTrigger.
      // A `from` tween applies its start state on creation, so if the trigger
      // never fires the copy sits at opacity 0 forever — invisible product
      // text on a page whose only job is selling. This way content is visible
      // by default and animation is purely additive.
      ScrollTrigger.create({
        trigger: group,
        start: 'top 85%',
        once: true,
        onEnter: function () {
          gsap.fromTo(
            kids,
            { opacity: 0, y: 26 },
            { opacity: 1, y: 0, duration: 0.6, ease: 'power2.out', stagger: 0.09, overwrite: true }
          );
        }
      });
    });
  }

  function init() {
    document.querySelectorAll('.ms-board').forEach(function (svg) {
      if (svg.dataset.msInit) return;
      svg.dataset.msInit = '1';
      initBoard(svg);
    });
    initReveals();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Horizon swaps sections in the theme editor without a page reload.
  document.addEventListener('shopify:section:load', init);
})();
